import type {GetAllAgentPoolsNormalizedApiArg} from '../services/rest'

export const getAgentPoolsArg = (): GetAllAgentPoolsNormalizedApiArg => ({
  fields: 'agentPool(id,name)',
  essential: true,
})
